<template>
  <div class="autocomplete-popup__container q-container-xl">
    <ClosePopupButtonDestkop />
    <OnFocusContainer v-show="!showResults"/>
    <AutocompleteContainer v-show="showResults"/>
  </div>
</template>

<script setup lang="ts">
import {toRefs} from 'vue';
import {usePopupStore} from "@/store/AutocompletePopup/PopupStore";

import AutocompleteContainer from '@/components/AutocompletePopup/ShowResults/AutocompleteContainer.vue';
import OnFocusContainer from '@/components/AutocompletePopup/OnFocus/OnFocusContainer.vue';
import ClosePopupButtonDestkop from "@/components/AutocompletePopup/ClosePopupButtonDestkop.vue";

const popupStore = usePopupStore()
const {showResults} = toRefs(popupStore)
</script>
<style>

</style>
